export default function CheckoutAllocationService(
    tripItemRailRecommendationService,
) {
    'ngInject';

    return {
        processRails,
    };

    function processRails(rails) {
        rails.forEach(processRailItem);
        return rails;
    }

    function processRailItem(rail) {
        const stationCodes = tripItemRailRecommendationService.getAllStationsCodes(rail)
            .join(' - ');
        Object.assign(rail, {stationCodes});
        return rail;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/allocation/checkout-allocation-service.js